$(() => {
    if($('#payment-page').length === 0) { return; }

    const priceBoxes = new PaymentPriceBoxes();
    priceBoxes.setup();
});

class PaymentPriceBoxes {

    setup() {
        $('.price-box').click((event) => {
            this.onClick($(event.currentTarget));
        });

        if(getCookie('price-variant')) { this.loadVariantFromCookie(); }
    }

    onClick(priceBox, deleteDiscountCookie = true) {

        if(deleteDiscountCookie) { deleteCookie('payment-discount-code'); }
        
        this.resetSelection();

        const priceBoxButton = priceBox.find('.select-button');
        const hasAmountBoxes = priceBox.hasClass('amount-boxes');

        priceBox.addClass('selected');
        $('.select-button-text', priceBoxButton).text(priceBoxButton.attr('data-alternativeText'));
        $('input', priceBoxButton).prop('checked', true);
        priceBoxButton.addClass('selected');

        const selectedVariant = priceBox.attr('data-variant')
        $('#price-variant-input').val(selectedVariant);

        setCookie('price-variant', selectedVariant, 60 * 5);


        if(!hasAmountBoxes) { new StandardPayment(priceBox) }
        else { new AmountPayment(priceBox); }
    }
    

    resetSelection() {
        $('.price-box').removeClass('selected');
        
        $('.price-box .select-button').each((index, element) => {
            $(element).removeClass('selected');
            $('.select-button-text', element).text($(element).attr('data-baseText'));
        });
    }

    loadVariantFromCookie() {
        const selectedVariant = getCookie('price-variant');
        const selectedPriceBox = $('#price-box-' + selectedVariant);

        this.onClick(selectedPriceBox, false);

        if(getCookie('payment-discount-code')) 
        {
            const discount = new PaymentDiscounts();

            const discountCode = getCookie('payment-discount-code');
            discount.checkDiscount(discountCode);
        }
    }

}